import { InjectionToken } from "@angular/core";
// import { LogoutReason } from "fundafe-common-core";

/**
 * @type {InjectionToken<SessionHandlerService>} Angular DI provider token for session handler service implementations.
 */
export const SessionHandlerServiceToken: InjectionToken<SessionHandlerService> = new InjectionToken<SessionHandlerService>("core.session-handler.service");

/**
 * The session handler service is the second layer of our session related logic. The session handler is the acting
 * layer: it listens to the session state changes and delivers the needed tasks to handle all session related jobs. It
 * is the one that calls the backend time-to-time to keep alive the backend side session if the user only active on the
 * client side. It is the one that calls the logout when a users asks for it. It is the one that resets the client side
 * state when the session ends one way or another. It is the one the redirects the user to the logout page at the end
 * of the session ending process.
 *
 * We should intialize this service upon application start by calling its `init()` method so it will listen to session
 * state changes and act when needed.
 */
export interface SessionHandlerService {
    /**
     * This method makes the session handler service listen to the session state and handle its changes.
     */
    init(): void;
    /**
     * This method starts the logout process. It calls the backend with a logout request and then it should also handle
     * the resetting of the redux state.
     * @param reason The reason of the logout.
     */
    logout(reason?: any /* LogoutReason */): void;
    /**
     * This method calls the backend to keep the session alive.
     */
    reviveSession(): void;

    clearSession(): void;
}
